import SearchCustom from "../../../components/custom/search-custom";
import { PromotionCampaign } from "../../../models/response/promotion-campaign";
import DateCustomInput from "../../../components/custom/date-input-custom";
import { getCurrentDayTime } from "../../../utils/time-utils";

interface PromotionCampaignFilterProps {
  searchValue: string;
  setSearchValue: (value: string) => void;
  item: PromotionCampaign;
  onTimeFromChange: (value: string) => void;
  onTimeToChange: (value: string) => void;
}

export const PromotionCampaignBrandFilter = ({
  searchValue,
  setSearchValue,
  item,
  onTimeFromChange,
  onTimeToChange,
}: PromotionCampaignFilterProps) => {

  return (
    <div
      className="flex items-center flex-wrap md:flex-row justify-between gap-4 md:gap-8"
      id="filter-bar"
    >
      <div className="flex flex-col flex-wrap gap-4">
        <div className="flex flex-wrap items-center gap-2">
          <span className="font-bold ">Tên loại chiến dịch khuyến mãi:</span>
          <span>{item?.name}</span>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <span className="font-bold ">Mô tả:</span>
          <span>{item?.description}</span>
        </div>

        <div className="flex items-center gap-4">
          <div className="flex flex-wrap items-center gap-2">
            <span className="font-bold ">Ngày tạo:</span>
            <span>{item?.created_at}</span>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <span className="font-bold ">Ngày cập nhật:</span>
            <span>{item?.updated_at}</span>
          </div>
        </div>
      </div>

      <div className="flex items-center flex-wrap gap-4">
        <div className="flex flex-col md:flex-row items-center flex-wrap gap-2 ">
          <div className="md:mt-0">
            <DateCustomInput
              className=" md:w-max"
              onChange={onTimeFromChange}
              maxDate={getCurrentDayTime()}
              type="datetime-local"
            />
          </div>

          <div className="">-</div>

          <div className="md:mt-0">
            <DateCustomInput
              className=" md:w-max"
              onChange={onTimeToChange}
              maxDate={getCurrentDayTime()}
              type="datetime-local"
            />
          </div>
        </div>

        <div className="w-full md:w-auto md:mt-0">
          <SearchCustom
            value={searchValue}
            onChange={(e) => setSearchValue(e)}
            className="w-full md:w-64"
          />
        </div>
      </div>
    </div>
  );
};

